import { METHOD, request } from '@/utils/request';
import { NEWS_CONSULTATION_FIND, NEWS_CONSULTATION_DETAILS } from './api';

export function newsConsultationFind(pagination, type) {
  return request(NEWS_CONSULTATION_FIND, METHOD.POST, {
    pageIndex: pagination.current,
    type,
  });
}
export function newsConsultationDetails(id) {
  return request(NEWS_CONSULTATION_DETAILS, METHOD.POST, {
    id,
  });
}
